/* vuex modules */

import imgGallery from './img-gallery'

export default {
  imgGallery
}